<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="components/country-change-request-form"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-widget.html"></require>
  <require from="controls/as-page-header"></require>
  <require from="controls/bs-form-lookup"></require>

  <div class="admin-country-change-request-create-screen">
    <as-page-jumbo icon="fas fa-sliders-h fa-fw" heading="Country change request" intro="Please select a country and fill up the form to request changes in country's settings. Once submitted, your request will be reviewed by the Regional Security Teams.">
      <div slot="default">
        <as-form-widget>
          <div slot="default">
            <div class="form-row flex-nowrap">
              <div class="col-md-12 col-lg-6">
                <bs-form-lookup label="Country" placeholder="Look up country" item.bind="country" options.bind="countries" value-path="name" stick-mode="true"></bs-form-lookup>
              </div>
            </div>
          </div>
        </as-form-widget>
      </div>
    </as-page-jumbo>
    <form class="container-fluid">
      <as-page-header if.bind="loaded" heading.bind="titleWithIcon" back-visible.bind="false">
        <div class="sc-buttons-container text-nowrap" slot="aside" if.bind="loaded">
          <button type="submit" class="btn btn-primary" af-mutex-click.call="submit()" if.bind="submitButtonVisible">
            <i class="fas fa-paper-plane"></i>Submit Request
          </button>
          <button type="button" class="btn btn-light" af-mutex-click.call="cancel()" if.bind="cancelButtonVisible">
            Reset
          </button>
        </div>
      </as-page-header>
      <country-change-request-form class="sc-content-appear" if="condition.bind: loaded; cache: false" approvers-editing.bind="approversEditing" model.bind="model" disabled.bind="!editing" changed.bind="changed" debug="true"></country-change-request-form>
    </form>
  </div>
</template>
